import { inviteMember, RbacRoleId } from "@risalabs_frontend_org/auth-wrapper";
import { useState } from "react";
import { controlToastState, Modal, TextInput } from "risa-oasis-ui_v2";

interface InvitationModalProps {
  facilityId: string;
  onModalClose?: (boolean) => void;
}

const HealthCareInvitationModal = (props: InvitationModalProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (data) => {
    if (data.name === "name") {
      setName(data.value);
    } else {
      setEmail(data.value);
    }
  };

  const handleInvite = async () => {
    if (!props.facilityId) {
      controlToastState("invitation-failed");
      return;
    }

    setLoading(true);
    try {
      await inviteMember(props.facilityId, {
        name,
        email,
        roleId: RbacRoleId.STANDARD_PHARMA,
      });
      controlToastState("invitation-success");
      props?.onModalClose && props?.onModalClose(false);
    } catch (error) {
      console.error("Error inviting member: ", error);
      controlToastState("invitation-failed");
    } finally {
      setName("");
      setEmail("");
      setLoading(false);
    }
  };

  const onModalClose = () => {
    setName("");
    setEmail("");
    props?.onModalClose && props?.onModalClose(false);
  };

  return (
    <Modal
      dialogId={"invitation-modal"}
      onSave={handleInvite}
      title={"Invite Member"}
      saveButtonText={loading ? "Inviting..." : "Invite"}
      cancelText={"Cancel"}
      disableSave={name.trim() === "" || email.trim() === "" || loading}
      onClose={onModalClose}
    >
      <div className="invitation-form-container">
        <form>
          <TextInput
            id={"name"}
            label={"Name"}
            required
            onChange={handleInputChange}
            error={name.trim() === "" ? "Please provide a name" : ""}
            resetField={name === ""}
          />
          <TextInput
            id={"email"}
            label={"Email"}
            required
            onChange={handleInputChange}
            error={email.trim() === "" ? "Please provide an email" : ""}
            resetField={email === ""}
          />
        </form>
      </div>
    </Modal>
  );
};

export default HealthCareInvitationModal;
